class ProductGallery extends HTMLElement {
  connectedCallback () {
    this.thumbs = new Swiper(this.querySelector('.product-gallery__thumbs'), {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: true,
      watchSlidesProgress: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        // When window width is <= 768px
        // 768: {
        //   direction: 'horizontal',
        //   slidesPerView: 'auto',
        //   spaceBetween: 10,
        // }
      }
    });

    this.gallery = new Swiper(this.querySelector('.product-gallery__main'), {
      loop: false,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next--pdp',
        prevEl: '.swiper-button-prev--pdp',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: this.thumbs,
      },
      keyboard: {
        enabled: true,
      }
    });
  }
}
customElements.define('product-gallery', ProductGallery);
